import React from 'react';

import DeleteIcon from '@material-ui/icons/Delete';
import EditIcon from '@material-ui/icons/Edit';

export default class ProductRow extends React.Component {
    state = {
        id: undefined,
    };

    static getDerivedStateFromProps(props, state) {
        if (props.id !== state.id || props.data !== state.data) {
            state.id = props.id;
            state.data = props.data;
            return state;
        }
        return null;
    }

    render() {
        const { data } = this.state;
        const tipo = this.props.types.find((element) => {
            return element.id && data.tipo && element.id.toString() === data.tipo.toString();
        });
        data.nombreTipo = tipo ? tipo.nombre : '';

        return (
            <div className="row shadow_down">
                <div className={'col barlow_regular_textwrap'}>{data.nombreTipo}</div>
                <div className={'col barlow_regular_textwrap'}>{data.valor}</div>
                <div className={'col barlow_regular_textwrap'}>{data.comentario}</div>
                <div className="colButtons center">
                    <EditIcon
                        className={'c_bluish hand'}
                        onClick={() => this.props.onEditEvent(data)}
                    />
                    <DeleteIcon
                        className={'c_bluish hand'}
                        onClick={() => this.props.onDelEvent(data)}
                    />
                </div>
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/components/complex/manage/provider/ContactRow.js